import styled from 'styled-components';
import copyIcon from 'assets/img/copy.svg';
import copySecondaryIcon from 'assets/img/copy-secondary.svg';
import { useState } from 'react';

function insertLineBreaks(text) {
  if (!text) return;
  return text.replaceAll(/\r?\n/g, '<br />');
}

export const ReportSummary = ({ summary, show }) => {
  const [isCopied, setCopied] = useState(false);

  function copyToClipboard(text) {
    setCopied(true);
    setTimeout(() => setCopied(false), 1700);
    navigator.clipboard.writeText(text);
  }

  const formattedText = insertLineBreaks(summary);

  if (!show) return null;

  return (
    <StyledReportSummary>
      <p className="summary-title">Report Summary</p>
      <div className="summary-divider" />
      <p
        dir="ltr"
        className="summary-text"
        dangerouslySetInnerHTML={{ __html: formattedText }}
      />
      <CopyButton
        onClick={() => !isCopied && copyToClipboard(summary)}
        isCopied={isCopied}
      >
        <img src={isCopied ? copySecondaryIcon : copyIcon} />
        <p dir="ltr" className="copy-text">
          {isCopied ? 'Copied !' : 'Copy To Clipboard'}
        </p>
      </CopyButton>
    </StyledReportSummary>
  );
};

const CopyButton = styled.div`
  .copy-text {
    color: ${({ isCopied }) => (isCopied ? `#3CC0C3` : `#753cbe`)};
    width: 100%;
  }
  cursor: pointer;
  margin: auto;
  display: flex;
  font-weight: 700;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 22px;
  width: 200px;
  height: 48px;
  border-radius: 16px;
  border-width: 1px;
  border-style: solid;
  padding: 12px 12px 12px 18px;
  border-color: ${({ isCopied }) => (isCopied ? `#3CC0C3` : `#753cbe`)};
  @media screen and (min-width: 1024px) {
    margin-top: 45px;
  }
`;

const StyledReportSummary = styled.div`
  padding: 16px 0;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background: #ffffff;
  p {
    color: #753cbe;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
  }

  .summary-divider {
    width: 100%;
    height: 1px;
    background-color: #d9d9d9;
    margin: 10px 0 14px;
  }

  .summary-text {
    color: #58595b;
    font-size: 16px;
    line-height: 24.26px;
    text-align: left;
    font-weight: 400;
    letter-spacing: 1px;
    margin: auto;
    padding: 0 40px;
  }
  @media screen and (min-width: 1024px) {
    padding: 0 200px 30px;

    .summary-title {
      font-size: 24px;
    }
    .summary-divider {
      height: 2px;
      background-color: #d8d8d8;
      margin: 20px 0 30px;
    }
  }
`;
